
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ICheckoutCartOffer } from '@/interfaces/Checkout';

import { goToDashboard } from '@/helpers/redirects';
import { hideModal } from '@/helpers/errors';
import { sendInteractEvent } from '@/helpers/events';

import Author from '@/app/features/Checkout/features/Offer/components/OfferCard/Author/Author.vue';
import { EInteractEventTrackerAction } from '@/app/features/InteractEventTracker/enums/EInteractEventTracker';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Author,
  }
})
export default class SuggestedOffer extends Vue {

  @Prop()
  private errorCode: string | number;

  @AppModule.Action
  private prepareCheckout: Function;

  @CheckoutModule.Getter
  private suggestedOffer: ICheckoutCartOffer;

  @Watch('errorCode', { immediate: true })
  private sendErrorEvent(errorCode: string | number) {
    if (
      errorCode == 1100 ||
      errorCode == 1101 ||
      errorCode == 1102 ||
      errorCode == 1103 ||
      errorCode == 1104
    )
      sendInteractEvent({
        action: EInteractEventTrackerAction.CHK_SHOW_RECOMMENDATION_LA,
        attributes: {
          recommended_content_url: process.env.VUE_APP_DASHBOARD_URL,
        }
      });
  }

  private get offerTitle(): string {
    return (this.suggestedOffer && this.suggestedOffer.display_name) || '';
  }

  private get offerDescription(): string {
    return (this.suggestedOffer && this.suggestedOffer.short_description) || '';
  }

  private async loadOffer() {
    const { slug = '' } = this.suggestedOffer;

    this.$router.replace({
      name: 'payment',
      params: { slug },
      query: {
        fromSuggested: '1',
      },
    });

    sendInteractEvent({
      action: EInteractEventTrackerAction.CHK_CLICKED_RECOMMENDATION_OFFER,
      attributes: {
        recommended_offer_id: this.suggestedOffer.id,
      },
    });

    await this.prepareCheckout({ slug });
    hideModal(this.errorCode);
  }

  private async goToRecommended() {
    sendInteractEvent({
      action: EInteractEventTrackerAction.CHK_CLICKED_RECOMMENDATION_LA,
      attributes: {
        recommended_content_url: process.env.VUE_APP_DASHBOARD_URL,
      },
    });

    goToDashboard();
  }

  private showRecommendedEvent() {
    sendInteractEvent({
      action: EInteractEventTrackerAction.CHK_SHOW_OFFER_RECOMMENDATION,
      attributes: {
        recommended_offer_id: this.suggestedOffer.id,
      },
    });
  }

  mounted () {
    this.showRecommendedEvent();
  }
}
